// Form validation for Ticket Status form
import { plaintextValidator } from '../fields';

const config = {};

export default {
  name: plaintextValidator({ mandatory: true }),
  description: plaintextValidator(config)
};
